import { ACTIONS, categories, labels } from '../../helpers/analytics-utils/constants';
import trackClickEvent from '../../helpers/analytics-utils/track-event';
export const createTrackUniversalFooterLinkClickTracker = tracker => label => {
  tracker(categories.UNIVERSAL, ACTIONS.clicked, labels.createFooterLink(label));
};
export const trackUniversalFooterLinkClick = createTrackUniversalFooterLinkClickTracker(trackClickEvent);